import axios from "axios";

const baseUrl = process.env.REACT_APP_URL_API_DASHBOARD;

export const listDatasets = async (headers) => {
  const res = await axios.get(`${baseUrl}/dashboard/datasets`, { headers });
  return res.data;
};

export const getDataset = async (datasetId, headers) => {
  const res = await axios.get(`${baseUrl}/dashboard/datasets/${datasetId}`, { headers });
  return res.data;
};

export const runQuery = async (payload, headers) => {
  const res = await axios.post(`${baseUrl}/dashboard/query`, payload, { headers });
  return res.data;
};

export const runProductPageable = async (payload, headers) => {
  const res = await axios.post(`${baseUrl}/product/pageable`, payload, { headers });
  return res.data;
};

export const exportExcel = async (payload, headers) => {
  return axios.post(
    `${baseUrl}/dashboard/export/excel`,
    payload,
    {
      headers,
      responseType: "blob",
    }
  );
};

export const exportGoogleSheet = async (payload, headers) => {
  console.log("Exporting to Google Sheet with payload:", payload);
  const res = await axios.post(
    `${baseUrl}/export/google-sheet`,
    payload,
    { headers }
  );

  return res.data;
};